import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import StorefrontLayout from '../components/layout/StorefrontLayout';
import { useAuth } from '../context/AuthContext';

function RecoverAccountPage() {
  const { t } = useTranslation();
  const { recoverAccountWithCode } = useAuth();
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    setSuccess(null);
    try {
      await recoverAccountWithCode({
        email,
        code,
        newEmail: newEmail.trim() || undefined,
        newPassword,
      });
      setSuccess(t('public.recover_success'));
      setCode('');
      setNewPassword('');
    } catch (err) {
      setError(err instanceof Error ? err.message : t('public.recover_failed'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <StorefrontLayout contentContained mainClassName="bg-slate-50">
      <div className="flex flex-1 items-center justify-center py-10">
        <section className="glass-panel w-full max-w-lg p-6 sm:p-8">
          <h1 className="mb-2 text-xl font-semibold tracking-tight text-slate-900">{t('public.recover_title')}</h1>
          <p className="mb-4 text-sm text-slate-600">{t('public.recover_intro')}</p>
          {error && <p className="mb-2 text-xs text-red-500">{error}</p>}
          {success && <p className="mb-2 text-xs text-emerald-600">{success}</p>}
          <form className="space-y-4" onSubmit={handleSubmit}>
            <input
              type="email"
              required
              placeholder={t('public.recover_email_ph')}
              className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="text"
              required
              placeholder={t('public.recover_code_ph')}
              className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm uppercase"
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
            />
            <input
              type="email"
              placeholder={t('public.recover_new_email_ph')}
              className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
            />
            <input
              type="password"
              required
              minLength={8}
              placeholder={t('public.recover_new_password_ph')}
              className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <button
              type="submit"
              disabled={submitting}
              className="inline-flex w-full items-center justify-center rounded-md bg-brand-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-brand-500 disabled:opacity-60"
            >
              {submitting ? t('public.recover_recovering') : t('public.recover_submit')}
            </button>
          </form>
          <p className="mt-4 text-xs text-slate-500">
            <Link to="/auth" className="underline hover:text-slate-700">
              {t('public.recover_back_signin')}
            </Link>
          </p>
        </section>
      </div>
    </StorefrontLayout>
  );
}

export default RecoverAccountPage;
